import React, { useEffect, useState } from 'react'
import HeaderImage from '../components/headerImage/HeaderImage'
import AttractionsList from '../components/attractionsList/AttractionsList';
import FreeAttractions from '../components/freeAttractions/FreeAttractions';
import PragueAreas from '../components/pragueAreas/PragueAreas';
import { useTranslation } from 'react-i18next';
import attractionStore from '../store/AttractionStore';
import languageStore from '../store/languageStore';
import { Spin } from 'antd';
import CustomHeader from '../components/header/Header';
import CustomFooter from '../components/footer/Footer';
import { LoadScript } from '@react-google-maps/api';
import "./Attractions.css"
import CustomHeaderDesktop from '../components/headerDesktop/Header';

export default function Attractions() {
  const { t } = useTranslation();
  const [freeAttractions, setFreeAttractions]= useState(attractionStore.freeAttractions);

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  useEffect(()=>{
    setFreeAttractions(attractionStore.freeAttractions);
  },[attractionStore.freeAttractions])

  useEffect(()=>{
    languageStore.initialize();
    attractionStore.fetchImageHeaderContent();
  },[])


  return (
    <div>
      <div className='mobile-header'>
        <CustomHeader />
      </div>
      <div className='desktop-header'>
        <CustomHeaderDesktop />
      </div>
      
      {
        attractionStore.loading?
        <Spin/>
        :
        <HeaderImage
        imageSrc={"https://static2.praguecoolpass.com/" + attractionStore?.imageHeaderContent?.mainImage?.web_image}
        title={attractionStore?.imageHeaderContent?.content ? (attractionStore?.imageHeaderContent?.content[languageStore?.selectedLanguage]?.title):null}
        description={attractionStore?.imageHeaderContent?.content ? attractionStore?.imageHeaderContent?.content[languageStore?.selectedLanguage]?.subtitle:null}
        photographer={attractionStore?.imageHeaderContent?.mainImage ? attractionStore?.imageHeaderContent?.mainImage?.author:null}
      />
      }
      
      <div style={{display:'flex', flexDirection: 'column'}}>
        <LoadScript
          googleMapsApiKey="AIzaSyBCx41DnuTv5Ld16npI3W0PFChJl9rf0-w"
          libraries={["places"]}
        >
          <AttractionsList/>
        </LoadScript>
        <FreeAttractions
              title={t("ATTRACTIONS_free_entry_attractions")}
              description={attractionStore?.attractionTitles.content? (stripHtmlTags(attractionStore?.attractionTitles?.content[languageStore?.selectedLanguage]?.free_entry_description)) :null}
              attractions={freeAttractions}
        />
        <PragueAreas areas={attractionStore.praguAreas}/>
      </div>
      <CustomFooter />
      
    </div>
  )
}
